// <predictive-search>: the field of the search panel. After 200 ms without typing it asks Shopify for the
// matching products as the `predictive-search` section (Liquid renders and escapes everything) and puts that
// HTML in #results. The last request wins: an older one is aborted and its answer is ignored.
class PredictiveSearch extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.input = this.querySelector("input[type=search]");
    this.results = this.querySelector("[data-results]");
    this.timer = 0;
    this.seq = 0;
    this.input.addEventListener("input", () => this.schedule());
  }

  disconnectedCallback() {
    clearTimeout(this.timer);
    this.controller?.abort();
  }

  schedule() {
    clearTimeout(this.timer);
    this.controller?.abort();
    this.seq++;
    if (!this.input.value.trim()) { this.results.innerHTML = ""; return; }
    this.timer = setTimeout(() => this.fetchResults(), 200);
  }

  async fetchResults() {
    const term = this.input.value.trim();
    if (!term) return;
    const seq = ++this.seq;
    this.controller = new AbortController();
    const url = `${this.dataset.url}?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=8&section_id=predictive-search`;
    try {
      const res = await fetch(url, { signal: this.controller.signal });
      if (!res.ok) throw new Error(String(res.status));
      const html = await res.text();
      // a newer keystroke (or a reset) happened while this was in flight
      if (seq !== this.seq) return;
      const hits = new DOMParser().parseFromString(html, "text/html").querySelector("[data-hits]");
      this.results.innerHTML = hits ? hits.innerHTML : "";
      document.dispatchEvent(new Event("jc:prices"));
    } catch (err) {
      // aborted requests are expected; on a real failure leave the field as it is, /search still works
      if (err.name !== "AbortError" && seq === this.seq) this.results.innerHTML = "";
    }
  }

  // empty the field and the results, dropping anything still in flight
  reset() {
    clearTimeout(this.timer);
    this.controller?.abort();
    this.seq++;
    this.input.value = "";
    this.results.innerHTML = "";
  }
}

if (!customElements.get("predictive-search")) customElements.define("predictive-search", PredictiveSearch);
